import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AIContentTools = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const aiTools = [
    {
      path: '/audio-analysis',
      icon: '🎙️',
      title: '음성 분석',
      description: '강의/회의 녹음을 텍스트로 변환하고 핵심 내용을 분석합니다.',
      status: 'available'
    },
    {
      path: '/content-summarize',
      icon: '📝',
      title: '콘텐츠 분석',
      description: '텍스트나 문서를 AI가 분석하여 핵심 내용과 인사이트를 도출합니다.',
      status: 'available'
    },
    {
      path: '/video-creator',
      icon: '🎬',
      title: '영상 제작',
      description: '숏폼 영상 제작, 이미지 업스케일, 이미지→비디오 변환',
      status: 'available'
    },
    {
      path: '/storyboard',
      icon: '📖',
      title: '스토리보드',
      description: 'AI가 스토리를 이미지 프롬프트로 변환하여 시각화합니다.',
      status: 'coming-soon'
    },
    {
      icon: '🔄',
      title: '콘텐츠 변환',
      description: '문체, 형식, 언어 등을 AI가 자동으로 변환합니다.',
      status: 'coming-soon'
    },
    {
      icon: '📰',
      title: '블로그 초안',
      description: '키워드만 입력하면 AI가 블로그 글을 작성합니다.',
      status: 'coming-soon'
    },
  ];

  return (
    <div className="p-6 px-8">
      <header className="mb-8 pb-5 border-b border-gray-200">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">AI 도구</h1>
        <p className="text-sm text-gray-600">다양한 AI 도구로 업무 효율을 높이세요</p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
        {aiTools.map((tool, index) => (
          <div
            key={index}
            className={`bg-white border border-gray-200 rounded-xl p-6 transition-all duration-200 relative ${
              tool.status === 'available'
                ? 'cursor-pointer hover:border-blue-500 hover:shadow-md hover:-translate-y-0.5'
                : 'hover:border-blue-500 hover:shadow-sm'
            }`}
            onClick={() => tool.path && tool.status === 'available' && navigate(tool.path)}
          >
            <div className="text-4xl mb-4">{tool.icon}</div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{tool.title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-4">{tool.description}</p>
            <span className={`inline-block px-3 py-1.5 rounded-md text-xs font-medium ${
              tool.status === 'available'
                ? 'bg-green-50 text-green-600'
                : 'bg-gray-100 text-gray-500'
            }`}>
              {tool.status === 'available' ? '사용 가능' : '준비 중'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AIContentTools;
